/**
 * @ngdoc service
 * @name cbl.telepass.wa.directive:tlpsProposta
 * @restrict E
 * @scope
 * @description Servizio che gestisce le configurazione delle soglie
 */
(function() {
  angular.module('cbl.telepass.wa').service('TlpsConfigurazioneSoglieSrvc', [
    '$http',
    'TlpsMessaggiFctr',
    'TLPS_CONSTANTS',
    'TlpsLabelSrvc',
    function($http, messaggiFctr, CONSTANTS, labelSrvc) {
      this.$http = $http;
      this.messaggiFctr = messaggiFctr;
      this.labelSrvc = labelSrvc;

      var self = this;

      /*
       * -------------------------------------
       *           PROMISE SERVIZI REST
       * -------------------------------------
       */

      /**
       * @ngdoc method
       * @name recuperaSoglie
       * @methodOf cbl.telepass.wa:configurazioneSoglieSrvc
       * @description Recupera la lista di filiale e le corrispondenti soglie
       */
      this.promiseRecuperaSoglie = function() {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.APPROVVIGIONAMENTO.SOGLIE
        });
      };

      /**
       * @ngdoc method
       * @name promiseSalvaSoglie
       * @methodOf cbl.telepass.wa:TlpsConfigurazioneSoglieSrvc
       * @description Effettua una chiamata http per aggiornare le soglie
       * @return {Promise} - Ritorna una promise contenente il dettaglio delle soglie
       */
      this.promiseSalvaSoglie = function(soglie) {
        return this.$http({
          method: 'PUT',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.APPROVVIGIONAMENTO.SOGLIE,
          data: soglie
        });
      };
    }
  ]);
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/tlpsApprovvigionamento/configurazioneSoglie/configurazioneSoglieSrvc.js
// module id = 10
// module chunks = 0